import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5f9f70f6")

_pushScopeId("data-v-5f9f70f6")
const _hoisted_1 = { class: "flex flex-row items-center justify-between" }
const _hoisted_2 = { class: "mt-3 text-10px" }
const _hoisted_3 = { class: "flex items-center text-black-lp-100" }
const _hoisted_4 = { class: "font-semibold flex items-center" }
const _hoisted_5 = {
  key: 0,
  class: "text-gray-lp-600 font-semibold text-12px"
}
const _hoisted_6 = {
  key: 1,
  class: "font-semibold text-12px"
}
const _hoisted_7 = {
  key: 2,
  class: "flex items-center gap-custom"
}
const _hoisted_8 = { class: "flex items-center gap-custom" }
const _hoisted_9 = {
  key: 3,
  class: "font-semibold text-black-lp-100"
}
const _hoisted_10 = {
  key: 4,
  class: "text-black-lp-100"
}
const _hoisted_11 = {
  key: 0,
  class: "w-full rounded-b-md font-medium text-10px flex flex-row items-center justify-between pt-2 border-t border-dashed mt-2 border-gray-lp-1600"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "inline-block align-middle" }, [
  /*#__PURE__*/_createVNode("b", { class: "flex items-center gap-custom" }, [
    /*#__PURE__*/_createVNode("div", { class: "dot rounded-full bg-gray-lp-800" }),
    /*#__PURE__*/_createVNode("div", { class: "dot rounded-full bg-gray-lp-800" }),
    /*#__PURE__*/_createTextVNode(" % ")
  ])
], -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "flex items-center gap-custom" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  width: "12",
  height: "12",
  viewBox: "0 0 45 45",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("label", {
    "data-testid": `adjust-stt-product-type-card-${_ctx.cardType}`,
    class: [
      'relative p-3 h-full block overflow-hidden rounded-xl',
      _ctx.isDisabled ? 'bg-gray-lp-2800' : 'bg-white cursor-pointer',
      _ctx.selected && !_ctx.isDisabled
        ? 'label-border-selected'
        : 'border border-gray-lp-1500'
    ],
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSelect && _ctx.onSelect(...args)))
  }, [
    _createVNode("input", {
      type: "radio",
      name: _ctx.radioName,
      value: _ctx.product.productType,
      checked: _ctx.selected,
      class: "z-10 absolute opacity-0",
      disabled: _ctx.isDisabled,
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSelect && _ctx.onSelect(...args)))
    }, null, 40, ["name", "value", "checked", "disabled"]),
    _createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("img", {
          class: "text-gray-lp-600 p-1",
          alt: "products-cards",
          src: _ctx.iconSrc,
          height: "22.4"
        }, null, 8, ["src"]),
        (!_ctx.isDisabled && !_ctx.product.hidePricingData)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "text-xs text-gray-lp-800 font-medium rounded-2xl border border-gray-lp-1500 bg-gray-lp-2800 py-0.5 px-2",
              style: `z-index: ${_ctx.selected ? -3 : 1};`
            }, _toDisplayString(_ctx.$t("bookingV4.product.sla", { sla: _ctx.slaRange })), 5))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_2, [
        _createVNode("p", _hoisted_3, [
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.productLabel), 1)
        ]),
        (_ctx.product.isEmbargo)
          ? (_openBlock(), _createBlock("p", _hoisted_5, _toDisplayString(_ctx.$t("bookingV4.product.embargo")), 1))
          : (!_ctx.product.isAvailable)
            ? (_openBlock(), _createBlock("p", _hoisted_6, _toDisplayString(_ctx.$t("bookingV4.product.unavailable")), 1))
            : (_ctx.isClient || _ctx.product.hidePricingData)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_ctx.currencyPrefix) + " ", 1),
                  _createVNode("span", _hoisted_8, [
                    (_openBlock(), _createBlock(_Fragment, null, _renderList(6, (n) => {
                      return _createVNode("div", {
                        key: n,
                        class: "dot rounded-full bg-gray-lp-800"
                      })
                    }), 64))
                  ])
                ]))
              : (_openBlock(), _createBlock("p", _hoisted_9, _toDisplayString(_ctx.formattedShippingCost), 1)),
        (_ctx.product.showMinWeightNote)
          ? (_openBlock(), _createBlock("p", _hoisted_10, _toDisplayString(_ctx.$t("bookingV4.product.minWeightNote")), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (!_ctx.isClient && !_ctx.hideDiscount)
      ? (_openBlock(), _createBlock("div", _hoisted_11, [
          _createVNode("p", {
            class: _ctx.isDisabled ? 'text-gray-lp-600' : 'text-gray-lp-800'
          }, [
            (_ctx.shouldMaskAgentDiscount)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t("bookingV4.product.discountAgent")) + " ", 1),
                  _hoisted_12
                ], 64))
              : (_openBlock(), _createBlock("b", _hoisted_13, _toDisplayString(_ctx.$t("bookingV4.product.discountAgentPercent", {
            percent: _ctx.product.commissionRate
          })), 1))
          ], 2),
          _createVNode("strong", {
            class: _ctx.isDisabled ? 'text-gray-lp-800' : 'text-green-lp-400'
          }, [
            (_ctx.shouldMaskAgentDiscount || _ctx.isDisabled)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: ["flex items-center", [{'gap-custom': _ctx.isDisabled}]]
                }, [
                  _createTextVNode(_toDisplayString(_ctx.currencyPrefix) + " ", 1),
                  _createVNode("span", _hoisted_14, [
                    (_openBlock(), _createBlock(_Fragment, null, _renderList(6, (n) => {
                      return _createVNode("div", {
                        key: n,
                        class: 
                `dot rounded-full ${
                  _ctx.isDisabled ? 'bg-gray-lp-800' : 'bg-green-lp-400'
                }`
              
                      }, null, 2)
                    }), 64))
                  ])
                ], 2))
              : (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(_ctx.formattedCommissionAmount), 1))
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.product.isRecommended)
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          "data-testid": "booking-v4-jenis-pengiriman-card-recommended",
          style: `z-index: ${!_ctx.selected ? 1 : -2};`,
          "aria-label": _ctx.$t('bookingV4.product.starTooltip'),
          class: [
        _ctx.isDisabled ? 'bg-gray-lp-1600' : 'bg-yellow-lp-1800',
        'rounded-bl-lg p-1 absolute top-0 right-1.5'
      ]
        }, [
          (_openBlock(), _createBlock("svg", _hoisted_16, [
            _createVNode("path", {
              d: "M19.2679 7.71456C20.59 4.92848 24.41 4.92848 25.7321 7.71456L28.9932 14.5865L36.285 15.6885C39.2414 16.1353 40.4218 19.9137 38.2826 22.0824L33.0061 27.4314L34.2517 34.9845C34.7567 38.0467 31.6663 40.3819 29.0221 38.9361L22.5 35.37L15.9779 38.9361C13.3337 40.3819 10.2433 38.0467 10.7483 34.9845L11.9939 27.4314L6.7174 22.0824C4.57818 19.9137 5.75863 16.1353 8.71496 15.6885L16.0069 14.5865L19.2679 7.71456Z",
              fill: _ctx.isDisabled ? '#A7A8AA' : '#F5A324'
            }, null, 8, ["fill"])
          ]))
        ], 14, ["aria-label"]))
      : _createCommentVNode("", true)
  ], 10, ["data-testid"]))
})